import { render, staticRenderFns } from "./StartDemoPopup.vue?vue&type=template&id=49df4aec&scoped=true"
import script from "./StartDemoPopup.vue?vue&type=script&lang=js"
export * from "./StartDemoPopup.vue?vue&type=script&lang=js"
import style0 from "./StartDemoPopup.vue?vue&type=style&index=0&id=49df4aec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49df4aec",
  null
  
)

export default component.exports